<template>
  <DetailsTicketModal
    v-if="showDetailsTicketModal"
    :ticketId="ticketIdSelected"
    @closeModal="closeAllModal"
  />
  <LogsTicketModal
    v-if="showLogsTicketModal"
    :ticketId="ticketIdSelected"
    @closeModal="closeAllModal"
  />
  <ContactTicketModal
    v-if="showContactTicketModal"
    :ticketId="ticketIdSelected"
    @closeModal="closeAllModal"
  />
  <AnswersModal
    v-if="showSurveyTicketModal"
    :uuid="surveyUuid"
    @closeModal="closeAllModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Tickets</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Confira os tickets sincronizados com o Ninja
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary ms-2"
          title="Sincronizar Tickets que estão sem Contatos/Técnicos"
          :disabled="isSyncingTickets || isSyncingLogsTicketsWithOutUsers"
          @click="syncTicketsLogsWithOutUsers"
        >
          <span v-if="isSyncingLogsTicketsWithOutUsers">
            <i class="ph ph-spinner spinner me-2" /> Realizando Sincronização
          </span>
          <span v-else>Forçar Tickets sem Contatos/Técnicos</span>
        </button>
        <button
          type="button"
          class="btn btn-primary ms-2"
          title="Sincronizar Tickets"
          :disabled="isSyncingTickets || isSyncingLogsTickets"
          @click="syncTickets"
        >
          <span v-if="isSyncingTickets">
            <i class="ph ph-spinner spinner me-2" /> Sincronizando Tickets
          </span>
          <span v-else-if="isSyncingLogsTickets">
            <i class="ph ph-spinner spinner me-2" /> Sincronizando Logs
          </span>
          <span v-else>Sincronizar Tickets</span>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12 col-md-3">
          <label class="form-label">Data Inicial (criação):</label>
          <input type="date" class="form-control" v-model="filters.startDate" />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Data Final (criação):</label>
          <input type="date" class="form-control" v-model="filters.endDate" />
        </div>
        <div class="col-12 col-md-4 pt-4 d-flex align-items-center">
          <label
            class="form-check form-switch form-check-reverse"
            title="Exibir somente com tickets sem contatos"
          >
            <input
              type="checkbox"
              class="form-check-input"
              :checked="filters.showOnlyTicketsWithOutUsers"
              @change="
                filters.showOnlyTicketsWithOutUsers =
                  !filters.showOnlyTicketsWithOutUsers
              "
            />
            <span class="form-check-label">
              Exibir somente tickets sem contatos
            </span>
          </label>
        </div>
        <div class="col-md-2 pt-4">
          <button
            class="btn btn-primary w-100"
            title="Buscar"
            @click="getTickets"
          >
            <span>Buscar</span>
          </button>
        </div>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListTickets
      v-else
      :tickets="tickets"
      @showDetailsTicket="showDetailsTicket"
      @showLogsTicket="showLogsTicket"
      @showContactTicket="showContactTicket"
      @showSurveysTicket="showSurveysTicket"
    />
  </div>
</template>

<script>
import DetailsTicketModal from '@/components/registers/tickets/DetailsTicketModal.vue'
import LogsTicketModal from '@/components/registers/tickets/LogsTicketModal.vue'
import ContactTicketModal from '@/components/registers/tickets/ContactTicketModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListTickets from '@/components/registers/tickets/ListTickets.vue'
import AnswersModal from '@/components/distributions/AnswersModal.vue'

export default {
  name: 'Tickets',

  components: {
    DetailsTicketModal,
    LogsTicketModal,
    ContactTicketModal,
    LoadingData,
    ListTickets,
    AnswersModal,
  },

  data() {
    return {
      filters: {
        startDate: '',
        endDate: '',
        showOnlyTicketsWithOutUsers: false,
      },
      isLoadingData: true,
      isSyncingTickets: false,
      isSyncingLogsTickets: false,
      isSyncingLogsTicketsWithOutUsers: false,
      pageLogsSync: 0,
      limitLogsSync: 25,
      showDetailsTicketModal: false,
      showLogsTicketModal: false,
      showContactTicketModal: false,
      showSurveyTicketModal: false,
      tickets: [],
      ticketIdSelected: null,
      surveyUuid: null,
    }
  },

  methods: {
    async getTickets() {
      try {
        this.isLoadingData = true
        this.tickets = await this.$store.dispatch('getTickets', this.filters)
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async syncTickets() {
      try {
        this.isSyncingTickets = true

        const response = await this.$store.dispatch('syncTickets')
        this.$root.$refs.notification.success(response.message)

        this.isSyncingTickets = false
        this.getTickets()

        this.syncTicketsLogs()
      } catch (error) {
        this.isSyncingTickets = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async syncTicketsLogs() {
      try {
        this.isSyncingLogsTickets = true

        const response = await this.$store.dispatch('syncTicketsLogs', {
          page: this.pageLogsSync,
          limit: this.limitLogsSync,
        })

        if (response.data.numberOfTickets > 0) {
          this.pageLogsSync += 1
          this.syncTicketsLogs()
        } else {
          this.$root.$refs.notification.success(response.message)
          this.isSyncingLogsTickets = false
          this.pageLogsSync = 0
          this.getTickets()
        }
      } catch (error) {
        this.isSyncingLogsTickets = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async syncTicketsLogsWithOutUsers() {
      try {
        this.isSyncingLogsTicketsWithOutUsers = true

        const response = await this.$store.dispatch(
          'syncTicketsLogsWithOutUsers',
        )
        this.$root.$refs.notification.success(response.message)

        this.isSyncingLogsTicketsWithOutUsers = false

        this.getTickets()
      } catch (error) {
        this.isSyncingLogsTicketsWithOutUsers = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    showDetailsTicket(ticketId) {
      this.ticketIdSelected = ticketId || null
      this.showDetailsTicketModal = true
    },

    showLogsTicket(ticketId) {
      this.ticketIdSelected = ticketId
      this.showLogsTicketModal = true
    },

    showContactTicket(ticketId) {
      this.ticketIdSelected = ticketId
      this.showContactTicketModal = true
    },

    showSurveysTicket(surveyUuid) {
      this.surveyUuid = surveyUuid
      this.showSurveyTicketModal = true
    },

    closeAllModal(needReload = false) {
      if (needReload) {
        this.getTickets()
      }
      this.showDetailsTicketModal = false
      this.showLogsTicketModal = false
      this.showContactTicketModal = false
      this.showSurveyTicketModal = false
    },
  },

  mounted() {
    const today = new Date()
    const twoMonthsAgoDate = new Date(
      today.getFullYear(),
      today.getMonth() - 5,
      today.getDate(),
    )
    this.filters.startDate = twoMonthsAgoDate.toISOString().slice(0, 10)
    this.getTickets()
  },
}
</script>
